import { Reveal } from "@/components/site/Reveal";

// Scrapbook / Polaroid photo treatment.
export default function Polaroid({
  src,
  alt,
  caption,
  rotate = "-3deg",
  tape = true,
  className = "",
  delay = 0,
}) {
  return (
    <Reveal delay={delay} className={className}>
      <figure
        className="relative inline-block bg-white p-3 pb-10 shadow-xl"
        style={{ transform: `rotate(${rotate})` }}
      >
        {tape && <span className="tape -top-3 left-1/2 -translate-x-1/2 -rotate-3" aria-hidden="true" />}
        <div className="overflow-hidden">
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
          />
        </div>
        {caption && (
          <figcaption className="font-marker absolute bottom-2 left-0 right-0 text-center text-lg text-[#14283A]">
            {caption}
          </figcaption>
        )}
      </figure>
    </Reveal>
  );
}
